// src/pages/PaymentSuccess.jsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/PaymentSuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const { paymentData, paymentIntent, booking, car, type } = location.state || {};

  useEffect(() => {
    // Redirect if no payment data
    if (!paymentData) {
      navigate('/');
    }
  }, [paymentData, navigate]);

  if (!paymentData) {
    return null;
  }

  const isBookingPayment = type === 'booking';
  const amount = paymentIntent?.amount_paisa ? (paymentIntent.amount_paisa / 100) : 0;

  return (
    <div className="payment-success-page">
      <div className="success-container">
        {/* Success Icon */}
        <div className="success-icon-wrapper">
          <div className="success-icon">
            <svg viewBox="0 0 52 52" className="checkmark">
              <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
              <path className="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
            </svg>
          </div>
        </div>

        {/* Success Message */}
        <h1 className="success-title">
          {isBookingPayment ? 'Booking Confirmed!' : 'Payment Successful!'}
        </h1>
        <p className="success-message">
          {isBookingPayment 
            ? 'Your car booking has been confirmed. We will contact you shortly.'
            : 'Your payment has been processed successfully.'}
        </p>

        {/* Payment Details */}
        <div className="payment-details-card">
          <h2 className="details-title">Payment Details</h2>
          
          <div className="detail-row">
            <span className="detail-label">Amount Paid</span>
            <span className="detail-value">₹{amount.toLocaleString('en-IN')}</span>
          </div>

          {paymentData.payment_id && (
            <div className="detail-row">
              <span className="detail-label">Payment ID</span>
              <span className="detail-value">#{paymentData.payment_id}</span>
            </div>
          )}

          {paymentIntent?.razorpay_order_id && (
            <div className="detail-row">
              <span className="detail-label">Order ID</span>
              <span className="detail-value small-text">{paymentIntent.razorpay_order_id}</span>
            </div>
          )}

          {isBookingPayment && booking && (
            <div className="detail-row">
              <span className="detail-label">Booking ID</span>
              <span className="detail-value">#{booking.id}</span>
            </div>
          )}

          <div className="detail-row">
            <span className="detail-label">Status</span>
            <span className="status-badge success">Confirmed</span>
          </div>
        </div>

        {/* Car Details (for booking payments) */}
        {isBookingPayment && car && (
          <div className="car-details-card">
            <h2 className="details-title">Car Details</h2>
            
            <div className="car-info-grid">
              <div className="car-info-item">
                <span className="info-icon">🚗</span>
                <div className="info-content">
                  <span className="info-label">Vehicle</span>
                  <span className="info-value">{car.brand} {car.model}</span>
                </div>
              </div>

              <div className="car-info-item">
                <span className="info-icon">📅</span>
                <div className="info-content">
                  <span className="info-label">Year</span>
                  <span className="info-value">{car.year}</span>
                </div>
              </div>

              <div className="car-info-item">
                <span className="info-icon">📍</span>
                <div className="info-content">
                  <span className="info-label">Location</span>
                  <span className="info-value">{car.location}</span>
                </div>
              </div>

              <div className="car-info-item">
                <span className="info-icon">⛽</span>
                <div className="info-content">
                  <span className="info-label">Fuel</span>
                  <span className="info-value">{car.fuel_type}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Next Steps */}
        <div className="next-steps-card">
          <h2 className="details-title">What's Next?</h2>
          <ul className="steps-list">
            {isBookingPayment ? (
              <>
                <li>✓ Our team will contact you within 24 hours</li>
                <li>✓ Schedule an inspection appointment</li>
                <li>✓ Complete the documentation process</li>
                <li>✓ Take delivery of your car</li>
              </>
            ) : (
              <>
                <li>✓ You will receive a confirmation email</li>
                <li>✓ Check your payment history for details</li>
                <li>✓ Contact support if you have any questions</li>
              </>
            )}
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="action-buttons">
          <button 
            className="btn-primary"
            onClick={() => navigate('/')}
          >
            Go to Home
          </button>
          <button 
            className="btn-secondary"
            onClick={() => navigate('/payments/history')}
          >
            View Payment History
          </button>
          {isBookingPayment && (
            <button 
              className="btn-secondary"
              onClick={() => navigate('/buy-cars')}
            >
              Browse More Cars
            </button>
          )}
        </div>

        {/* Support Info */}
        <div className="support-info">
          <p>Need help? Contact us at:</p>
          <div className="support-contacts">
            <a href="tel:+9194253 37223" className="support-link">
              📞 +91  94253 37223
            </a>
            <a href="mailto:support@caryugo.com" className="support-link">
              ✉️ support@caryugo.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;